<template>
    <v-card elevation="0" style="border-radius: 8px">
        <v-card-title class="font14 pt-1 greyText font-weight-regular">
            <v-icon>mdi-chart-box-outline</v-icon>
            {{ $t('eventStats.liveStats') }}
        </v-card-title>
        <v-card-text>
            <AppEventStatsRow
                v-if="
                    eventStats.yellow_home !== undefined &&
                    eventStats.yellow_away !== undefined &&
                    eventStats.yellow_home !== null &&
                    eventStats.yellow_away !== null
                "
                :header-text="$t('eventStats.yellowCards')"
                :background-color="$vuetify.theme.dark ? '#2c2f33' : '#FEF7DC'"
                :filled-color="$vuetify.theme.dark ? '#E4AC01' : '#FEE8A4'"
                filled-darker-color="#FECA30"
                :value-one="eventStats.yellow_home"
                :value-two="eventStats.yellow_away"
            ></AppEventStatsRow>

            <AppEventStatsRow
                v-if="
                    eventStats.fouls_home !== undefined &&
                    eventStats.fouls_away !== undefined &&
                    eventStats.fouls_home !== null &&
                    eventStats.fouls_away !== null
                "
                :header-text="$t('eventStats.fouls')"
                :background-color="$vuetify.theme.dark ? '#2c2f33' : '#E8E8E8'"
                :filled-color="$vuetify.theme.dark ? '#545454' : '#A6A6A6'"
                filled-darker-color="#666666"
                :value-one="eventStats.fouls_home"
                :value-two="eventStats.fouls_away"
                numbers-class="orangeDarkText"
            ></AppEventStatsRow>

            <AppEventStatsRow
                v-if="
                    eventStats.possession_time_home !== undefined &&
                    eventStats.possession_time_away !== undefined &&
                    eventStats.possession_time_home !== null &&
                    eventStats.possession_time_away !== null
                "
                :header-text="$t('eventStats.possession')"
                :background-color="$vuetify.theme.dark ? '#2c2f33' : '#EDF5EA'"
                :filled-color="$vuetify.theme.dark ? '#4D7939' : '#B7D6A8'"
                :filled-darker-color="$vuetify.theme.dark ? '#6aa84f' : '#6AA84F'"
                :with-percent="true"
                :value-one="eventStats.possession_time_home"
                :value-two="eventStats.possession_time_away"
            ></AppEventStatsRow>

            <AppEventStatsRow
                v-if="
                    eventStats.attacks_home !== undefined &&
                    eventStats.attacks_away !== undefined &&
                    eventStats.attacks_home !== null &&
                    eventStats.attacks_away !== null
                "
                :header-text="$t('eventStats.attacks')"
                :background-color="$vuetify.theme.dark ? '#2c2f33' : '#EDF5EA'"
                :filled-color="$vuetify.theme.dark ? '#4D7939' : '#B7D6A8'"
                :filled-darker-color="$vuetify.theme.dark ? '#6aa84f' : '#6AA84F'"
                :value-one="eventStats.attacks_home"
                :value-two="eventStats.attacks_away"
            ></AppEventStatsRow>

            <AppEventStatsRow
                v-if="
                    eventStats.dangerous_attacks_home !== undefined &&
                    eventStats.dangerous_attacks_away !== undefined &&
                    eventStats.dangerous_attacks_home !== null &&
                    eventStats.dangerous_attacks_away !== null
                "
                :header-text="$t('eventStats.dangerousAttacks')"
                :background-color="$vuetify.theme.dark ? '#2c2f33' : '#EDF5EA'"
                :filled-color="$vuetify.theme.dark ? '#4D7939' : '#B7D6A8'"
                :filled-darker-color="$vuetify.theme.dark ? '#6aa84f' : '#6AA84F'"
                :value-one="eventStats.dangerous_attacks_home"
                :value-two="eventStats.dangerous_attacks_away"
            ></AppEventStatsRow>

            <AppEventStatsRow
                v-if="
                    eventStats.shots_home !== undefined &&
                    eventStats.shots_away !== undefined &&
                    eventStats.shots_home !== null &&
                    eventStats.shots_away !== null
                "
                :header-text="$t('eventStats.shots')"
                :background-color="$vuetify.theme.dark ? '#2c2f33' : '#EDF5EA'"
                :filled-color="$vuetify.theme.dark ? '#4D7939' : '#B7D6A8'"
                :filled-darker-color="$vuetify.theme.dark ? '#6aa84f' : '#6AA84F'"
                :value-one="eventStats.shots_home"
                :value-two="eventStats.shots_away"
            ></AppEventStatsRow>

            <AppEventStatsRow
                v-if="
                    eventStats.shots_on_target_home !== undefined &&
                    eventStats.shots_on_target_away !== undefined &&
                    eventStats.shots_on_target_home !== null &&
                    eventStats.shots_on_target_away !== null
                "
                :header-text="$t('eventStats.shotsOnTarget')"
                :background-color="$vuetify.theme.dark ? '#2c2f33' : '#EDF5EA'"
                :filled-color="$vuetify.theme.dark ? '#4D7939' : '#B7D6A8'"
                :filled-darker-color="$vuetify.theme.dark ? '#6aa84f' : '#6AA84F'"
                :value-one="eventStats.shots_on_target_home"
                :value-two="eventStats.shots_on_target_away"
            ></AppEventStatsRow>

            <AppEventStatsRow
                v-if="
                    eventStats.hit_woodwork_home !== undefined &&
                    eventStats.hit_woodwork_away !== undefined &&
                    eventStats.hit_woodwork_home !== null &&
                    eventStats.hit_woodwork_away !== null
                "
                :header-text="$t('eventStats.hitWoodwork')"
                :background-color="$vuetify.theme.dark ? '#2c2f33' : '#EDF5EA'"
                :filled-color="$vuetify.theme.dark ? '#4D7939' : '#B7D6A8'"
                :filled-darker-color="$vuetify.theme.dark ? '#6aa84f' : '#6AA84F'"
                :value-one="eventStats.hit_woodwork_home"
                :value-two="eventStats.hit_woodwork_away"
            ></AppEventStatsRow>

            <AppEventStatsRow
                v-if="
                    eventStats.corners_home !== undefined &&
                    eventStats.corners_away !== undefined &&
                    eventStats.corners_home !== null &&
                    eventStats.corners_away !== null
                "
                :header-text="$t('eventStats.corners')"
                :background-color="$vuetify.theme.dark ? '#2c2f33' : '#EDF5EA'"
                :filled-color="$vuetify.theme.dark ? '#4D7939' : '#B7D6A8'"
                :filled-darker-color="$vuetify.theme.dark ? '#6aa84f' : '#6AA84F'"
                :value-one="eventStats.corners_home"
                :value-two="eventStats.corners_away"
            ></AppEventStatsRow>
        </v-card-text>
    </v-card>
</template>

<style scoped></style>

<script>
    import AppEventStatsRow from 'Pages/core/event/EventStatsRow.vue';

    export default {
        name: 'app-eventStatsSidePanel',
        components: { AppEventStatsRow },
        props: {
            tableHeight: {
                default: undefined,
                type: Number,
            },
        },
        watch: {},
        mounted() {
            console.log('Component %s mounted.', this.$options.name);
        },
        data() {
            return {};
        },

        methods: {
            isEmpty(value) {
                return _.isEmpty(value);
            },
        },
        computed: {
            event() {
                return this.$store.getters['EventModule/getEvent'];
            },

            eventStats() {
                return this.$store.getters['EventModule/getStats'];
            },
        },
    };
</script>
